// extracted by mini-css-extract-plugin
export default {"disabled":"FormDisabled_disabled__2MxIv","text":"FormDisabled_text__u6-YH","button":"FormDisabled_button__xzcBT"};